(() => {
  // Units-left ticker for the delivery box: the count ticks DOWN while the box
  // is visible. The progress bars themselves need no JS - they ride the shared
  // [data-sb-progress-root] reveal in motion.css.
  const FIRST_TICK_MS = 5000;
  const INTERVAL_MS = 60000;
  // Never tick into implausible territory: the counts are not wired to real
  // inventory, so a long-lived tab must not run them to absurd numbers.
  const DOWN_FLOOR = 100;

  const locale = document.documentElement.lang || undefined;

  const relativeDates = [...document.querySelectorAll('[data-sb-delivery-relative-date]')]
    .filter((host) => host instanceof HTMLElement);

  if (relativeDates.length > 0) {
    const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' });
    const renderRelativeDates = () => {
      const now = new Date();
      relativeDates.forEach((host) => {
        const days = Number.parseInt(host.dataset.sbDeliveryDays || '', 10);
        if (!Number.isFinite(days)) return;
        const target = new Date(now);
        target.setHours(12, 0, 0, 0);
        target.setDate(target.getDate() + days);
        host.textContent = formatter.format(target);
      });
    };
    const scheduleMidnightRefresh = () => {
      renderRelativeDates();
      const nextMidnight = new Date();
      nextMidnight.setHours(24, 0, 1, 0);
      window.setTimeout(scheduleMidnightRefresh, nextMidnight.getTime() - Date.now());
    };

    scheduleMidnightRefresh();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) renderRelativeDates();
    });
  }
  document.querySelectorAll('[data-sb-delivery-batches] [data-sb-delivery-units]').forEach((host) => {
    const root = host.closest('[data-sb-delivery-batches]');
    if (!(root instanceof HTMLElement) || !(host instanceof HTMLElement)) return;

    let count = Number.parseInt(host.dataset.sbDeliveryUnits || '', 10);
    if (!Number.isFinite(count) || count <= DOWN_FLOOR) return;

    const formatter = new Intl.NumberFormat(locale);
    let flow = null;
    let firstTickTimer = 0;
    let intervalTimer = 0;
    let inView = false;

    if ('customElements' in window) {
      customElements.whenDefined('number-flow').then(() => {
        const element = document.createElement('number-flow');
        element.locales = locale;
        element.update(count);
        host.replaceChildren(element);
        flow = element;
      });
    }

    const render = () => {
      if (flow) {
        flow.update(count);
        return;
      }
      host.textContent = formatter.format(count);
    };

    const stop = () => {
      window.clearTimeout(firstTickTimer);
      window.clearInterval(intervalTimer);
      firstTickTimer = 0;
      intervalTimer = 0;
    };

    const atLimit = () => count <= DOWN_FLOOR;

    const tick = () => {
      if (atLimit()) {
        stop();
        return;
      }
      count -= 1;
      render();
    };

    const start = () => {
      if (firstTickTimer || intervalTimer || atLimit()) return;
      firstTickTimer = window.setTimeout(() => {
        firstTickTimer = 0;
        tick();
        intervalTimer = window.setInterval(tick, INTERVAL_MS);
      }, FIRST_TICK_MS);
    };

    // Timers only run while the box is on screen and the tab is visible, so a
    // backgrounded or scrolled-past page costs nothing.
    const sync = () => {
      if (inView && !document.hidden) start();
      else stop();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        inView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
        sync();
      }, { threshold: 0.5 });
      observer.observe(root);
    } else {
      inView = true;
      sync();
    }

    document.addEventListener('visibilitychange', sync);
  });
})();
